// Chat branch step 1 — install the extension (overhaul §6.2, panel 02·ext). Runs the full
// extension bridge (detect → silent credential handshake); auto-advances the moment the
// handshake reports `connected`, so the extension already holds credentials before the
// consent step kicks off the backfill. Only appears in the chat branch.

import { useEffect, useRef } from 'react';
import { siteLabel } from '../../lib/sites';
import { CHROME_STORE_URL } from '../../lib/constants';
import { useExtensionBridge } from '../../hooks/useExtensionBridge';

export function ChatInstallStep({ sourceId, onConnected, onBack, onSignOut }: {
  sourceId: string;
  onConnected: () => void;
  onBack: () => void;
  onSignOut: () => void;
}) {
  const { status, error, retry } = useExtensionBridge();
  const fired = useRef(false);
  const label = siteLabel(sourceId);

  useEffect(() => {
    if (status === 'connected' && !fired.current) {
      fired.current = true;
      onConnected();
    }
  }, [status, onConnected]);

  return (
    <>
      <div className="crumb">STEP 02 · ADD THE EXTENSION</div>
      <div className="wh">{label} needs the <span className="em">extension</span>.</div>
      <p className="wp">
        Chat sources are captured in your browser, so Terum needs its Chrome extension to read
        your {label} conversations. Under a minute - we detect it automatically and bring you
        right back to finish connecting. (Shown only because it isn't installed yet.)
      </p>
      <div style={{ marginTop: 22, display: 'flex', gap: 12, alignItems: 'center', flexWrap: 'wrap' }}>
        <button className="btn btn-primary" onClick={() => window.open(CHROME_STORE_URL, '_blank', 'noopener')}>
          Add to Chrome <span className="arr">→</span>
        </button>
        {status === 'error' ? (
          <span style={{ display: 'inline-flex', alignItems: 'center', gap: 7, fontSize: 12, color: 'var(--rose)' }}>
            ⚠ {error || 'Connection failed.'}{' '}
            <a style={{ cursor: 'pointer', textDecoration: 'underline' }} onClick={retry}>Try again</a>
          </span>
        ) : (
          <span style={{ display: 'inline-flex', alignItems: 'center', gap: 7, fontSize: 12, color: 'var(--inkS)' }}>
            <span className="dot amb" /> Waiting for the extension…
          </span>
        )}
      </div>
      <div className="wiz-foot">
        <button className="btn btn-secondary" onClick={onBack}>← Pick another source</button>
        <a style={{ cursor: 'pointer', color: 'var(--inkS)', fontSize: 13 }} onClick={onSignOut}>Sign out</a>
        <span className="prog">Step 2 · extension</span>
      </div>
    </>
  );
}
